import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  crearPrestamo,
  fetchAutorizados,
  obtenerObras,
} from "../redux/actions/index";
import { useNavigate } from "react-router-dom"; // Importamos el hook useNavigate
import SweetAlert from "sweetalert2";
import axios from "axios";

const Carrito = ({ carrito, setCarrito, clienteId, usuarioId }) => {
  const [fechaPrestamo, setFechaPrestamo] = useState(""); // Estado para la fecha de préstamo
  const dispatch = useDispatch();
  const autorizadosCliente = useSelector((state) => state.autorizadosCliente); // Estado de las obras desde Redux
  const [autorizadoId, setAutorizadoId] = useState("");
  const navigate = useNavigate(); // Usamos el hook useNavigate
  const { loading, error } = useSelector((state) => state);
  const obras = useSelector((state) => state.obras); // Estado de las obras desde Redux
  const [obraSeleccionada, setObraSeleccionada] = useState("");

  // Eliminar un producto del carrito
  const eliminarProducto = (id) => {
    setCarrito(carrito.filter((producto) => producto.id !== id));
  };

  // Registrar el préstamo
  const handleRegistrarPrestamo = async () => {
    const productosParaRegistrar = carrito.map(({ id, cantidad }) => ({
      productoId: id,
      cantidad,
    }));
  
    try {
      // Registrar el préstamo de productos
      await dispatch(
        crearPrestamo({
          clienteId, // ID del cliente
          usuarioId, // ID del usuario
          productos: productosParaRegistrar, // Lista de productos con cantidades
          fechaDevolucion: fechaPrestamo, // Fecha de devolución seleccionada
          IdObra: obraSeleccionada, // ID de la obra
          autorizadoId: autorizadoId, // ID del autorizado
        })
      );
  
      // Generar el remito PDF después de registrar el préstamo
      const productos = carrito; // Los productos del carrito
      const comentario = "Comentario de préstamo"; // Agregar un comentario si es necesario
      const idRemito = `P-${Date.now()}`; // ID de préstamo único (basado en la fecha y hora)
  
      const response = await axios.post(
        "/api/remitoPrestamo",
        {
          id: idRemito,
          productos: productos, // Array de productos con nombre y cantidad
          clienteId: clienteId, // ID del cliente
          autorizadoId: autorizadoId, // ID del autorizado (si aplica)
          comentario: comentario, // Comentarios adicionales
          usuarioId: usuarioId, // ID del usuario que realiza la operación
          obraId: obraSeleccionada, // ID de la obra asociada
          fechaDevolucion: fechaPrestamo, // Fecha de devolución en formato adecuado
        },
        { responseType: "blob" } // Indicamos que la respuesta será un archivo binario (PDF)
      );
  
      // Crear un enlace para descargar el PDF
      const blob = new Blob([response.data], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `remito_prestamo_${idRemito}.pdf`;
      link.click(); // Iniciar la descarga del PDF
  
      // Mostrar mensaje de éxito con SweetAlert
      SweetAlert.fire(
        "Éxito",
        "El préstamo de productos y el remito se generaron correctamente.",
        "success"
      );
  
      // Vaciar el carrito después de registrar el préstamo y generar el remito
      setCarrito([]);
  
      // Redirigir al usuario a una página de éxito o inicio
      navigate("/inicio");
    } catch (error) {
      console.error("Error al registrar el préstamo:", error);
  
      // Mostrar mensaje de error con SweetAlert
      SweetAlert.fire(
        "Error",
        "No se pudo registrar el préstamo de productos o generar el remito.",
        "error"
      );
    }
  };
  
  useEffect(() => {
    dispatch(fetchAutorizados(clienteId)); // Cargar las obras al montar el componente
    dispatch(obtenerObras());
  }, [dispatch]);

  return (
    <div className="w-full min-h-screen h-full">
      <h1 className="flex text-white justify-center text-4xl font-bold">
        Carrito
      </h1>
      {error && <p style={{ color: "red" }}>{error}</p>}
      <section className="text-gray-600 body-font">
        <div className="container px-5 py-8 mx-auto">
          <div className="flex justify-between -mx-4 -mb-10 text-center">
            <div className="mx-auto flex w-full flex-col justify-center px-5 pt-0 md:h-[unset] md:max-w-[95%] mt-10">
              <div className="h-full w-full rounded-lg">
                <div className="rounded-lg border bg-card text-card-foreground shadow-sm h-full w-full border-zinc-200 p-0 dark:border-zinc-800 sm:overflow-auto">
                  <div className="overflow-x-scroll xl:overflow-x-hidden">
                    <div className="relative w-full overflow-auto">
                      <table className="table-fixed w-full">
                        <thead className="[&amp;_tr]:border-b border-b-[1px] border-zinc-200 p-6 dark:border-zinc-800">
                          <tr className="dark:border-zinc-800">
                          <th
                              className="h-12 px-4 align-middle font-medium text-muted-foreground cursor-pointer border-zinc-800 border-r-2 pl-5 pr-4 pt-2 text-start"
                              colspan="1"
                            >
                              <p className="text-xs font-semibold text-textoClaro">
                                Nombre Producto
                              </p>
                            </th>

                            <th
                              className="h-12 px-4 align-middle font-medium text-muted-foreground cursor-pointer border-zinc-800 border-r-2 pl-5 pr-4 pt-2 text-start"
                              colspan="1"
                            >
                              <p className="text-xs font-semibold text-textoClaro">
                                Categoria
                              </p>
                            </th>
                            <th
                              className="h-12 px-4 align-middle font-medium text-muted-foreground cursor-pointer border-zinc-800 border-r-2 pl-5 pr-4 pt-2 text-start"
                              colspan="1"
                            >
                              <p className="text-xs font-semibold text-textoClaro">
                                Cantidad
                              </p>
                            </th>
                            <th
                              className="h-12 px-4 align-middle font-medium text-muted-foreground cursor-pointer border-zinc-800 border-r-2 pl-5 pr-4 pt-2 text-start"
                              colspan="1"
                            >
                              <p className="text-xs font-semibold text-textoClaro">
                                Stock Actual
                              </p>
                            </th>
                            <th
                              className="h-12 px-4 align-middle font-medium text-muted-foreground [&amp;:has([role=checkbox])]:pr-0 cursor-pointer border-zinc-200 pl-5 pr-4 pt-2 text-start dark:border-zinc-800"
                              colspan="1"
                            ></th>
                          </tr>
                        </thead>
                        <tbody className="[&amp;_tr:last-child]:border-0">
                          {carrito.map((producto) => (
                            <tr className="border-b-2 border-zinc-800 transition-colors min-h-screen h-full hover:bg-muted/50  px-6 dark:hover:bg-gray-900">
                              <td className="p-4 align-middle w-max border-r-2 border-zinc-800 py-5 pl-5 pr-4">
                              <p className="text-sm font-medium text-textoClaro">
                                  {producto?.nombre}
                                </p>
                              </td>
                              <td className="p-4 align-middle w-max border-r-2 border-zinc-800 py-5 pl-5 pr-4">
                                <p className="text-sm font-medium text-textoClaro">
                                    {producto?.categoria?.nombre}
                                  </p>
                              </td>
                              <td className="p-4 align-middle w-max border-r-2 border-zinc-800 py-5 pl-5 pr-4">
                                <p className="text-sm font-medium text-textoClaro">
                                    {producto.cantidad}
                                  </p>
                              </td>
                              <td className="p-4 align-middle w-max border-r-2 border-zinc-800 py-5 pl-5 pr-4">
                                <p className="text-sm font-medium text-textoClaro">
                                    {producto?.stock}
                                  </p>
                                
                              </td>
                              <td className="p-4 align-middle [&amp;:has([role=checkbox])]:pr-0 w-max border-b-[1px] border-zinc-200 py-5 pl-5 pr-4 dark:border-white/10">
                                <button
                                  className="inline-flex mt-3 ml-3 px-2 py-1 rounded-lg z-10 bg-red-500 text-sm font-medium text-white select-none"
                                  onClick={() => eliminarProducto(producto.id)}
                                >
                                  Eliminar
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="mt-8 flex flex-wrap items-center gap-4">
                  <div className="w-full sm:w-auto flex flex-col sm:flex-row items-start sm:items-center gap-2">
                    <label className="text-white">Fecha de Devolución</label>
                    <input
                      type="date"
                      value={fechaPrestamo}
                      onChange={(e) => setFechaPrestamo(e.target.value)}
                      className="px-4 py-2 rounded bg-gray-100 text-black w-full sm:w-auto"
                    />
                  </div>

                  <div className="w-full sm:w-auto flex flex-col sm:flex-row items-start sm:items-center gap-2">
                    <label className="text-white">Autorizado</label>
                    <select
                      value={autorizadoId}
                      onChange={(e) => setAutorizadoId(e.target.value)}
                      className="p-2 rounded bg-gray-100 text-black w-full sm:w-auto"
                    >
                      <option value="">Seleccionar autorizado</option>
                      {autorizadosCliente.map((autorizado) => (
                        <option key={autorizado.id} value={autorizado.id}>
                          {autorizado.nombre}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="w-full sm:w-auto flex flex-col sm:flex-row items-start sm:items-center gap-2">
                    <label className="text-white">Obra</label>
                    <select
                      value={obraSeleccionada}
                      onChange={(e) => setObraSeleccionada(e.target.value)}
                      className="px-4 py-2 rounded bg-gray-100 text-black w-full sm:w-auto"
                    >
                      <option value="" disabled>
                        Selecciona una obra
                      </option>
                      {obras?.map((obra) => (
                        <option key={obra.id} value={obra.id}>
                          {obra.nombre}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="w-full sm:w-auto">
                    <button
                      disabled={!carrito.length}
                      onClick={handleRegistrarPrestamo}
                      className={`px-4 py-2 rounded ${
                        carrito.length ? "bg-blue-500" : "bg-gray-400"
                      } text-white`}
                    >
                      Registrar Préstamo
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Carrito;
